import React from "react";
import HimalyaDiamondPellets from "../assets/PackageImages/HimalyaDiamond.png"
import AadarshGold from  "../assets/PackageImages/AadarshGold.png"
import AnjaliSoecial from "../assets/PackageImages/AnjaliSpecial.png"
import DairyGold from "../assets/PackageImages/DairyGold.png"
import DaivikGold from "../assets/PackageImages/DaivikGold.png"
import GoshalaGoldGolden from "../assets/PackageImages/GoshalaGold(Golden).png"
import GoshalaGoldPink from "../assets/PackageImages/GoshalaGold(Pink).png"
import KuberGreen from "../assets/PackageImages/Kuber(Green).png"
import KuberWhite from "../assets/PackageImages/Kuber(White).png"
import VitaminGold from "../assets/PackageImages/VitaminGold.png"

export const projects = {
  group1: [
    {
      id: "Himalya-diamond-pellets",
      title: "Himalya Diamond Pellets",
      imageSrc: HimalyaDiamondPellets,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
    {
      id: "Gopalan-diamond-pellets",
      title: "Gopalan Diamond Pellets",
      imageSrc: GoshalaGoldPink,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
    {
      id: "Kuber-diamond-pellets",
      title: "Kuber Diamond Pellets",
      imageSrc: KuberWhite,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
  ],
  group2: [
    {
      id: "Adarsh-gold-pellets",
      title: "Adarsh Gold Pellets",
      imageSrc: AadarshGold,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
    {
      id: "Gaushala-gold-pellets",
      title: "Gaushala Gold Pellets",
      imageSrc: GoshalaGoldGolden,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
    {
      id: "Dairy-gold-pellets",
      title: "Dairy Gold Pellets",
      imageSrc: DairyGold,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
  ],
  group3: [
    {
      id: "Daivik-mix",
      title: "Daivik Mix",
      imageSrc: DaivikGold,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
    {
      id: "Kuber-mix",
      title: "Kuber Mix",
      imageSrc: KuberGreen,
      description: "Product Description in short.",
      details: [
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled.",
        "and demoralized by the charms of pleasure of the moment, so blinded by desire.",
        "that they cannot foresee the pain and trouble that are bound to ensue; and equal blame",
      ],
    },
  ],
};

const projectsData = () => {
  return <div>projectsData</div>;
};

export default projectsData;
